// extracted by mini-css-extract-plugin
module.exports = {"PRODUCT_BANNER":"ProductBanner_PRODUCT_BANNER__2wMI_"};